export const SET_USER = 'SET_USER';
export const SET_TOKEN = 'SET_TOKEN';
export const UNSET_USER = 'UNSET_USER';
export const UNSET_TOKEN = 'UNSET_TOKEN';
export const SET_USER_PLAN = 'SET_USER_PLAN';
export const SET_USER_BILLING_INFO = 'SET_USER_BILLING_INFO';
export const UNSET_USER_PLAN = 'UNSET_USER_PLAN';
export const SET_STRIPE_INTENT = 'SET_STRIPE_INTENT';
